import { InputAdornment, OutlinedInput } from '@mui/material';
import React from 'react';
import { InputProps } from './VegaTextField';

interface ExtraProps {
  Icon?: React.ReactNode;
}

export interface ITextProps extends InputProps, ExtraProps {
  type?: 'number' | 'text';
  readOnly?: boolean;
  min?: number | string;
  max?: number | string;
  height?: number | string;
  defaultValue?: number | string;
}

const VegaOutLineTextField = ({
  key,
  value,
  onChange,
  placeholder,
  Icon,
  type,
  readOnly,
  min,
  max,
  height,
  defaultValue,
  textFieldWidth,
  disabled,
}: ITextProps) => {
  return (
    <>
      <OutlinedInput
        fullWidth
        id={key}
        type={type}
        name={key}
        readOnly={readOnly}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        onWheel={(e: any) => e.target.blur()}
        placeholder={placeholder}
        disabled={disabled}
        inputProps={{
          min,
          max,
          step: 1,
        }}
        size="small"
        sx={{
          borderRadius: '7px',
          height: height ?? '50px',
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              borderColor: '#AFAFAF',
              borderWidth: '1px',
              borderRadius: '9px',
            },
            ':hover fieldset': {
              borderColor: 'red',
            },
          },
          ...(textFieldWidth && { width: textFieldWidth }),
          '& .MuiInputBase-input': {
            fontFamily: `var(--font-Aspekta-450) !important`,
            fontSize: '13px',
            lineHeight: '120%',
            color: '#1B1D22',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#EBEBEB',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#EBEBEB',
            borderWidth: '1px',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#EBEBEB',
            borderWidth: '1px',
          },
        }}
        startAdornment={
          Icon && <InputAdornment position="start">{Icon}</InputAdornment>
        }
      />
    </>
  );
};

export default VegaOutLineTextField;
